/**
 * 白名单
 * 在白名单内的请求不需要携带 token
 */

const whiteList: string[] = [
  '/login',
  '/refresh_token',
  '/passkey/login/options',
  '/passkey/login',
  // 访客聊天邀请探测接口（无鉴权）。防止 admin 登录态下打开访客链接时，
  // 请求拦截器向 tokenless 的访客请求注入 admin Bearer 令牌
  '/chat/invitation-token',
];

// 判断是否必须携带 token
export const isRequireAddToken = (url: string = ''): boolean =>
  !whiteList.some((item) => url === item);
